<template>
    <div ref="tabOC">
        <v-tabs 
            v-model="tab" 
            class="global-tabs" 
            show-arrows 
            :touchless="true" 
            center-active
            background-color="transparent">
            <v-tab 
                class="tab-oc-global global-tab" 
                v-for="item in tabsItems" 
                :key="item.ConvertInvalidJsxElement"
                :to="item.href">
                {{item.name}}
            </v-tab>
            <v-tabs-slider class="divider-tabs"></v-tabs-slider>
        </v-tabs>
    </div>
</template>
<script>
export default {
    data: () => ({
        tabsItems: [
            {
                name: 'Ingresos',
                href: '/home/income_and_expenses/incomes'
            },
            {
                name: 'Egresos',
                href: '/home/income_and_expenses/expenses'
            }
        ],
        tab: 0
    })
}
</script>